export class HideInspectionTemplateError extends Error {
  constructor(
    message: string = 'Failed to hide inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'HideInspectionTemplateError';
  }
}
